import { Controller } from "@hotwired/stimulus"

/**
 * Radio Card Controller
 *
 * Makes radio buttons styled as selectable cards work correctly.
 * Updates visual state when selection changes.
 */
export default class extends Controller {
  static targets = ["card"]
  static classes = ["selected", "unselected"]

  connect() {
    this.updateVisualState()
  }

  select(event) {
    // Let the radio button get selected naturally
    this.updateVisualState()
  }

  updateVisualState() {
    this.cardTargets.forEach(card => {
      const radio = card.querySelector('input[type="radio"]')
      if (radio && radio.checked) {
        card.classList.remove(...this.unselectedClasses)
        card.classList.add(...this.selectedClasses)
        card.querySelector('svg')?.classList.remove('invisible')
      } else {
        card.classList.remove(...this.selectedClasses)
        card.classList.add(...this.unselectedClasses)
        card.querySelector('svg')?.classList.add('invisible')
      }
    })
  }
}
